<template>
  <div>
    <Form @keydown.native.enter.prevent="doSubmit" :label-width="140" :rules="ruleValidate" :model="formData">
      <Row>
        <Col span="12">
          <FormItem label="油站名称：" prop="gas_name">
            <Input v-model="formData.gas_name" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="地址：" prop="gas_address">
            <Input v-model="formData.gas_address" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="省市区：" prop="province">
            <Cascader v-model="formData.province" :data="province_county_data"></Cascader>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="营业开始时间：" prop="work_start_time">
            <Input v-model="formData.work_start_time" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="营业结束时间：" prop="work_end_time">
            <Input v-model="formData.work_end_time" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="联系人：" prop="contact_user">
            <Input v-model="formData.contact_user" placeholder=""></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="联系人电话：" prop="contact_mobile">
            <Input v-model="formData.contact_mobile" placeholder="用于登录，默认密码为手机号码"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="油品来源：" prop="private_gas_source">
            <Input v-model="formData.private_gas_source" placeholder="如中石油、中石化"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="价格：" prop="price">
            <Input v-model="formData.price" placeholder="">
              <span slot="append">元/L</span>
            </Input>
          </FormItem>
        </Col>
      </Row>

      <Form-item>
        <Button type="primary" @click="doSubmit">确定</Button>
      </Form-item>
    </Form>

  </div>
</template>

<script>
  import Editor from '@/components/editor'
  import config from '@/config/base-config'
  export default {
    name: "edit",
    components:{Editor},
    data(){
      return {
        formData:{
          gas_name:'',
          gas_address:'',
          work_start_time:'',
          work_end_time:'',
          contact_user:'',
          contact_mobile:'',
          private_gas_source:'',
          province:'',
          price:'',
        },
        province_county_data:[],
        companys: [],
        ruleValidate:{

        },
      }
    },
    methods:{
      init(){
        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
        })
      },
      async doSubmit(){
        let res = await this.$commonFun.postProxy('admin/gas/addStation',this.formData)
        this.$commonFun.dealApiResult(res)
        this.$emit('edit-success')
      },

    },
    mounted() {
      this.init()

    },
  }
</script>

<style scoped>

</style>
